import { render, staticRenderFns } from "./ProjectsOverviewPage.vue?vue&type=template&id=31ca221c&scoped=true&"
import script from "./ProjectsOverviewPage.vue?vue&type=script&lang=js&"
export * from "./ProjectsOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsOverviewPage.vue?vue&type=style&index=0&id=31ca221c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca221c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ca221c')) {
      api.createRecord('31ca221c', component.options)
    } else {
      api.reload('31ca221c', component.options)
    }
    module.hot.accept("./ProjectsOverviewPage.vue?vue&type=template&id=31ca221c&scoped=true&", function () {
      api.rerender('31ca221c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsOverviewPage.vue"
export default component.exports